import { Modal } from 'react-bootstrap';
import { GreenCheck } from '../../../../../assets/images/images';

/**
 * Component for displaying a modal with a success message.
 *
 * This component displays a modal with a success message and an icon.
 *
 * @component
 * @param {Object} props - The properties passed down to the component.
 * @param {boolean} props.isOpen - Indicates whether the modal is open.
 * @param {Function} props.onClose - Function to handle modal close.
 * @returns {JSX.Element} - Rendered Component.
 */
function Component({ isOpen, onClose }) {
    return (
        <Modal className='onboarding' show={isOpen} onHide={onClose} backdrop="static">
            <Modal.Header>
                <figure><img src={GreenCheck} alt="Logo" /></figure>
            </Modal.Header>

            <Modal.Body className='text-center'>
                <h5 className='m6'>Comment Saved</h5>
                <p className='m10 text-text'>Comment Saved Successfully</p>
            </Modal.Body>
        </Modal>
    );
}

// Export the Component as the default export
export default Component;
